// dup

/*
 * @param  {number} amount    Amount to be formatted in cents.
 * @param  {object} options   Formatting options.
 * @return {string}           Formatted result i.e. $1,000,000
 */
import { i18n } from '~/i18n'

type Options = {
  precision?: number
  unit?: string
  separator?: string
  delimiter?: string
  removeNegativePrefix?: boolean
}
export const formatCurrency = function (amount = 0, opts: Options = {}) {
  if (amount < 0 && opts.removeNegativePrefix) {
    amount = -1 * amount
  }

  const { precision = 2, unit = '$', separator = '.', delimiter = ',' } = opts
  const currencyOptions = {
    precision,
    unit,
    separator,
    delimiter,
  }

  return i18n.numberToCurrency(amount / 100, currencyOptions)
}

export default formatCurrency

export const centsToDollarString = (cents?: number) =>
  cents ? (cents / 100).toFixed(2) : ''

export const dollarStringToCents = (dollarString: string) =>
  Math.round(parseFloat(dollarString) * 100)
